export default __webpack_public_path__ + "static/media/chola.c50cd2a4.png";